import { checkSeo } from "@/utilities/helpers"
import { graphql } from "gatsby"
import Seo from "gatsby-plugin-wpgraphql-seo"
import React, { FC } from "react"

import { EcommerceTemplate } from "./ecommerce-template/index"

interface EcommercePageProps {
  data?: any
}

const EcommercePage: FC<EcommercePageProps> = (props) => {
  const { data } = props

  const ecommerceData = data?.wpPage?.template?.ecommerceData
  const seoData = checkSeo(props.data?.wpPage, "")

  return (
    <>
      {seoData && <Seo post={seoData} />}
      <EcommerceTemplate data={ecommerceData} />
    </>
  )
}

export const pageQuery = graphql`
  query EcommerceQuery($databaseId: Int!) {
    wpPage(databaseId: { eq: $databaseId }) {
      databaseId
      template {
        ... on WpEcommerceTemplate {
          ecommerceData {
            hero {
              banner {
                text
                bannerUrl {
                  url
                  title
                  target
                }
              }
              pill
              title
              subtitle
              subtitleAddition
              link {
                target
                title
                url
              }
            }
            useCases {
              anchor
              title
              tabs {
                title
                icon {
                  altText
                  title
                  localFile {
                    publicURL
                  }
                }
              }
              caption
            }
            howItWorks {
              anchor
              title
              video {
                localFile {
                  publicURL
                }
              }
              videoFramePreview {
                altText
                title
                gatsbyImage(width: 1120, placeholder: NONE, quality: 100)
              }
              link {
                target
                title
                url
              }
            }
            customers {
              title
              logos {
                image {
                  altText
                  title
                  gatsbyImage(width: 320, placeholder: NONE, quality: 100)
                }
              }
              testimonials {
                quote
                description
                author
              }
            }
            benefits {
              anchor
              benefitsList {
                pill {
                  color
                  title
                }
                title
                description
                image {
                  altText
                  title
                  gatsbyImage(width: 1120, placeholder: NONE, quality: 100)
                }
              }
            }
            faq {
              anchor
              title
              items {
                question
                answer
              }
            }
            finalCta {
              title
              description
              button {
                target
                title
                url
              }
              newsletterCta {
                title
                description
                formData {
                  buttonTitle
                  fieldGroupName
                  formId
                  gtmEventName
                  redirect {
                    target
                    title
                    url
                  }
                  requireBusinessEmail
                  thankYou
                  zoomInfoId
                }
              }
            }
          }
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
  }
`

export default EcommercePage
